import { LockIcon, LockOpenIcon } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../tooltip';

export function LockToggle({ locked, onToggle }: { locked: boolean; onToggle: () => void }) {
	return (
		<TooltipProvider>
			<Tooltip>
				<TooltipTrigger asChild>
					<button
						type="button"
						onClick={onToggle}
						aria-label={locked ? 'Unlock field' : 'Lock field'}
						className="group text-muted-foreground hover:text-foreground ml-2 shrink-0 transition-colors"
					>
						{locked ? (
							<>
								<LockIcon className="size-4 group-hover:hidden" />
								<LockOpenIcon className="hidden size-4 group-hover:block" />
							</>
						) : (
							<>
								<LockOpenIcon className="size-4 group-hover:hidden" />
								<LockIcon className="hidden size-4 group-hover:block" />
							</>
						)}
					</button>
				</TooltipTrigger>
				<TooltipContent className="max-w-xs text-center">
					<p>{locked ? 'Unlock to edit' : 'Lock'}</p>
					<p className="text-muted-foreground mt-1 text-xs">
						Frequent changes to this field can negatively impact SEO.
					</p>
				</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
}
